/**
 * Marks the next gate/bootstrap cycle as an explicit user Connect.
 * Required so disconnect latch can be cleared only via coordinator.connect().
 */

const EXPLICIT_CONNECT_KEY = "medmic_explicit_connect_v1";
/** After "Use another account", prefer MSAL active account over sticky latch id. */
const PREFER_ACTIVE_ACCOUNT_KEY = "medmic_prefer_active_account_v1";

export function markMedMicExplicitConnect() {
  try {
    sessionStorage.setItem(EXPLICIT_CONNECT_KEY, "1");
  } catch {
    /* ignore */
  }
}

export function consumeMedMicExplicitConnect() {
  try {
    const v = sessionStorage.getItem(EXPLICIT_CONNECT_KEY);
    if (v) sessionStorage.removeItem(EXPLICIT_CONNECT_KEY);
    return v === "1";
  } catch {
    return false;
  }
}

export function peekMedMicExplicitConnect() {
  try {
    return sessionStorage.getItem(EXPLICIT_CONNECT_KEY) === "1";
  } catch {
    return false;
  }
}

export function markMedMicPreferActiveAccount() {
  try {
    sessionStorage.setItem(PREFER_ACTIVE_ACCOUNT_KEY, "1");
  } catch {
    /* ignore */
  }
}

export function consumeMedMicPreferActiveAccount() {
  try {
    const v = sessionStorage.getItem(PREFER_ACTIVE_ACCOUNT_KEY);
    if (v) sessionStorage.removeItem(PREFER_ACTIVE_ACCOUNT_KEY);
    return v === "1";
  } catch {
    return false;
  }
}
